import React from "react";
import styled from "styled-components";
import { GlassmorphismButton } from "../styled/shared/Glassmorphism";

const MenuButtonContainer = styled(GlassmorphismButton)`
  position: fixed;
  top: 10px;
  left: 10px;
  border-radius: 50%;
  padding: 8px;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    display: none;
  }
`;
const MenuButtonIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    fill="currentColor"
    className="bi bi-list"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
    />
  </svg>
);
export default function MenuButton({ setIsMenuOpen }) {
  return (
    <MenuButtonContainer onClick={() => setIsMenuOpen(true)}>
      {MenuButtonIcon}
    </MenuButtonContainer>
  );
}
